import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import PrebuiltBetClassic from 'modules/prebuilt-bets/prebuilt-bet/view/classic/index.js';
import PrebuiltBetUtils from 'modules/prebuilt-bets/prebuilt-bet/utils.js';
import { useSameMarketSubHeader } from 'modules/prebuilt-bets/prebuilt-bet/hooks/index.js';

const { PREBUILT_ACCA } = MojitoServices.Analytics.types.SELECTION_TYPE;
const { FlexPane, Text } = MojitoPresentation.Components;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;
const analyticsContext = new AnalyticsContextBuilder().withAnalyticsPath(PREBUILT_ACCA).build();

const Header = ({ config, promotionText, subHeader }) => (
    <FlexPane class="ta-header" config={config.headerContainer}>
        <FlexPane config={config.headerTextContainer}>
            {Boolean(promotionText) && (
                <Text class={'ta-promotionText'} config={config.promotionText}>
                    {promotionText}
                </Text>
            )}
            {subHeader && (
                <Text class={'ta-subHeaderText'} config={config.marketName}>
                    {subHeader}
                </Text>
            )}
        </FlexPane>
    </FlexPane>
);

const PrebuiltAccaClassic = props => {
    const {
        mojitoTools: { config, style },
        market,
        event,
        promotionText,
        onEventClick,
        imgUrl,
        icons,
        colorMode,
    } = props;

    const cardConfig = PrebuiltBetUtils.resolveCardDetails(style, colorMode || config.view.mode);
    const { isSameMarketBet, subHeader } = useSameMarketSubHeader(market?.preBuiltBetBuilderParts);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetClassic
                config={cardConfig.view}
                market={market}
                event={event}
                showMarketName={!subHeader}
                onEventClick={onEventClick}
                imgUrl={imgUrl}
                colorMode={colorMode}
                class={'ta-PrebuiltAcca'}
                icons={isSameMarketBet ? icons : undefined}
            >
                {cardConfig.view.showCardHeader && (
                    <Header
                        config={cardConfig}
                        promotionText={promotionText}
                        subHeader={subHeader}
                    />
                )}
            </PrebuiltBetClassic>
        </AnalyticsContextExtender>
    );
};

PrebuiltAccaClassic.getStyle = (config, mode, merge) =>
    PrebuiltBetUtils.buildCardDetails(config, 'prebuiltAccaDetailsDark', merge);

export default PrebuiltAccaClassic;
